<div id="login" fxLayout="column">

    <div id="login-form-wrapper" fxLayout="column" fxLayoutAlign="center center">

        <div id="login-form" [@animate]="{value:'*',params:{duration:'300ms',y:'100px'}}">

            <div class="logo">
                <img src="assets/images/logos/tisza-group-black-220.png">
            </div>

            <div class="title">{{'Login to account' | translate }}</div>

            <form name="loginForm" [formGroup]="loginForm" novalidate (ngSubmit)="onSubmit()">

                <mat-form-field appearance="outline">
                    <mat-label>{{'Email' | translate}}</mat-label>
                    <input matInput formControlName="emailaksljf">
                    <!-- <mat-icon matSuffix class="secondary-text">mail</mat-icon> -->
                    <mat-error *ngIf="loginForm.get('emailaksljf').hasError('required')">
                        {{'Email is required' | translate}}
                    </mat-error>
                    <mat-error *ngIf="!loginForm.get('emailaksljf').hasError('required') &&
                            loginForm.get('emailaksljf').hasError('emailaksljf')">
                        {{'Please enter a valid email address' | translate}}
                    </mat-error>
                </mat-form-field>

                <mat-form-field appearance="outline">
                    <mat-label>{{'Password' | translate}}</mat-label>
                    <input matInput [type]="hide ? 'password' : 'text'" formControlName="passwordlkjkl">
                    <!-- <mat-icon matSuffix class="secondary-text">vpn_key</mat-icon> -->
                    <mat-icon matSuffix class="secondary-text cursor-pointer" (click)="hide = !hide">{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                    <mat-error>
                        {{'Password is required' | translate}}
                    </mat-error>
                </mat-form-field>

                <mat-error *ngIf="serverBadLogin">{{badLoginMsg | translate}}</mat-error>

                <!-- H o n e y p o t -->
                <label class="ohno" for="email"></label>
                <input class="ohno" autocomplete="off" type="email" id="email" name="email"
                    placeholder="Your e-mail here">
                <label class="ohno" for="password"></label>
                <input class="ohno" autocomplete="off" type="password" id="password" name="password"
                    placeholder="Your password here">

                <div class="remember-forgot-password" fxLayout="row" fxLayout.xs="column"
                    fxLayoutAlign="space-between center">
                    <!-- <mat-checkbox class="remember-me" aria-label="Remember Me">
                        Remember Me
                    </mat-checkbox>  -->

                    <a class="forgot-password" [routerLink]="'/forgot-password'">
                        {{'Forgot Password?' | translate}}
                    </a>
                </div>

                <button mat-raised-button color="accent" class="submit-button text-uppercase" aria-label="LOG IN"
                    [disabled]="loginForm.invalid">
                    {{'Login' | translate}}
                </button>

            </form>

            <div class="separator">
                <span class="text">{{'OR' | translate }}</span>
            </div>

            <button mat-raised-button class="google" (click)="signInWithGoogle()">
                {{'Log in with Google' | translate }}
            </button>

            <button mat-raised-button class="facebook" (click)="signInWithFB()">
                {{'Log in with Facebook' | translate }}
            </button>

            <!-- <div class="register" fxLayout="column" fxLayoutAlign="center center">
                <span class="text">Don't have an account?</span>
                <a class="link" [routerLink]="'/register'">Create an account</a>
            </div> -->

        </div>

    </div>

</div>